jQuery(document).ready(function($) {
   
    jQuery('#aus-tab').click(function() {
        jQuery('.tab-lists').removeClass('active');
        jQuery('.tab').hide();
        var id = $(this).attr('data-id'); 
        console.log(id);
        jQuery(this).parent('li').addClass('active');
        jQuery('#'+id).show();
    });
    jQuery('#int-tab').click(function() {
        jQuery('.tab-lists').removeClass('active');
        jQuery('.tab').hide();
        var id = $(this).attr('data-id'); 
        console.log(id);
        jQuery(this).parent('li').addClass('active');
        jQuery('#'+id).show();
    });

});